module.exports = {
    monthsShort : "Jan._Feb._Mar._Apr._May_Jun._Jul._Aug._Sep._Oct._Nov._Dec.".split("_"),
    longDateFormat: {
        LT : "h:mm A",
        L : "MM/DD/YYYY",
        LL : "MMM D YYYY",
        LLL : "MMM D YYYY LT",
        LLLL : "dddd, MMMM Do YYYY LT"
    }
};